import {
  FETCH_HOME_VIDEO_REQUEST,
  FETCH_HOME_VIDEO_SUCCESS,
  FETCH_HOME_VIDEO_ERROR,
  FETCH_USER_VERSION_VALIDATION_REQUEST,
  FETCH_USER_VERSION_VALIDATION_SUCCESS,
  FETCH_USER_VERSION_VALIDATION_ERROR,
  FETCH_SPRINT_NOTES_REQUEST,
  FETCH_SPRINT_NOTES_SUCCESS,
  FETCH_SPRINT_NOTES_ERROR,
  RESET_SPRINT_NOTES,
} from 'actionTypes'

const defaultState = {
  video: '',
  sprintNotes: '',
  isFetching: false,
  error: null,
}

const home = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_HOME_VIDEO_REQUEST:
    case FETCH_USER_VERSION_VALIDATION_REQUEST:
    case FETCH_SPRINT_NOTES_REQUEST:
      return {
        ...state,
        isFetching: true,
      }

    case FETCH_HOME_VIDEO_SUCCESS:
      return {
        ...state,
        video: action.payload,
        isFetching: false,
        error: null,
      }

    case FETCH_HOME_VIDEO_ERROR:
      return {
        ...state,
        video: '',
        isFetching: false,
        error: action.payload,
      }

    case FETCH_USER_VERSION_VALIDATION_SUCCESS:
      return {
        ...state,
        userVersion: action.payload,
        error: null,
      }

    case FETCH_USER_VERSION_VALIDATION_ERROR:
      return {
        ...state,
        userVersion: '',
        isFetching: false,
        error: action.payload,
      }

    case FETCH_SPRINT_NOTES_SUCCESS:
      return {
        ...state,
        sprintNotes: action.payload,
        isFetching: false,
        error: null,
      }

    case FETCH_SPRINT_NOTES_ERROR:
      return {
        ...state,
        sprintNotes: '',
        isFetching: false,
        error: action.payload,
      }

    case RESET_SPRINT_NOTES:
      return {
        ...state,
        sprintNotes: '',
      }

    default:
      return state
  }
}

export default home
